import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/styles.scss'
import '../node_modules/vue-select/dist/vue-select.css';
import 'bootstrap' // Required to have javascript default functionality

createApp(App).use(store).use(router).mount('#app')
